import httpService from "./http.service";

class LensesService {
  getLensesUrl = "/lenses";
  //   lensesAC = "/lens/ac";

  getLenses = () => {
    return httpService.get(this.getLensesUrl);
  };
  createLens = (model) => {
    return httpService.post("/lenses", model);
  };
  editLens = (id, model) => {
    return httpService.patch("/lenses/" + id, model);
  };
  deleteLens = (id) => {
    return httpService.delete("/lenses/" + id);
  };
}

const lensesService = new LensesService();
export default lensesService;
